import React from "react";

const TimelineHeaders = ({ visibleNodes }) => {
  if (!visibleNodes || visibleNodes.length === 0) return null;

  // Ensure all nodes have valid numeric x and y
  const validNodes = visibleNodes.filter(n => typeof n.x === 'number' && typeof n.y === 'number' && !isNaN(n.x) && !isNaN(n.y));
  if (validNodes.length === 0) return null;

  const columns = Array.from(new Set(validNodes.map((n) => n.level))).sort((a, b) => a - b);
  if (columns.length === 0) return null;

  // Find min and max Y of the nodes safely
  const minNodeY = Math.min(...validNodes.map(n => n.y));
  const maxNodeY = Math.max(...validNodes.map(n => n.y + (n.height || 85)));

  const headerHeight = 60;
  // Place the separator line 40px above the highest node
  const separatorY = minNodeY - 40;
  // Place the top line above the header
  const topY = separatorY - headerHeight;
  // Place the bottom line 40px below the lowest node
  const bottomY = maxNodeY + 40;

  // Calculate boundaries based on the metadata added in flowHelpers.js
  const startX = Math.min(...validNodes.map(n => n.timelineColLeft || 0));
  const endX = Math.max(...validNodes.map(n => (n.timelineColLeft || 0) + (n.timelineColWidth || 350)));

  return (
    <g className="timeline-headers">
      {/* Horizontal grid lines */}
      <line x1={startX} y1={topY} x2={endX} y2={topY} stroke="#b0b0b0" strokeWidth="2" />
      <line x1={startX} y1={separatorY} x2={endX} y2={separatorY} stroke="#b0b0b0" strokeWidth="2" />
      <line x1={startX} y1={bottomY} x2={endX} y2={bottomY} stroke="#b0b0b0" strokeWidth="2" />

      {columns.map((colIndex, i) => {
        const nodeInCol = validNodes.find((n) => n.level === colIndex);
        if (!nodeInCol) return null;

        const leftLineX = nodeInCol.timelineColLeft;
        const colWidth = nodeInCol.timelineColWidth;
        const textX = leftLineX + colWidth / 2;
        const textY = topY + headerHeight / 2 + 3;

        return (
          <g key={`col-${colIndex}`}>
            {/* Left vertical line for this column */}
            <line
              x1={leftLineX}
              y1={topY}
              x2={leftLineX}
              y2={bottomY}
              stroke="#e0e0e0"
              strokeWidth="2"
            />
            {/* Draw the right boundary for the very last column */}
            {i === columns.length - 1 && (
              <line
                x1={leftLineX + colWidth}
                y1={topY}
                x2={leftLineX + colWidth}
                y2={bottomY}
                stroke="#e0e0e0"
                strokeWidth="2"
              />
            )}
            
            <text
              x={textX}
              y={textY}
              fontSize="20"
              fontWeight="600"
              fill="#5f6368"
              textAnchor="middle"
              alignmentBaseline="middle"
            >
              {nodeInCol.timelineRange || `Week ${nodeInCol.timelineWeek}`}
            </text>
          </g>
        );
      })}
    </g>
  );
};

export default TimelineHeaders;
